import React from "react";
import {
  Modal,
  Box,
  Button,
  Grid,
  Typography,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";

interface AddPayoutAccountModalProps {
  open: boolean;
  handleClose: () => void;
}

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    paddingLeft: theme.spacing(2),
  },
  "& .MuiSvgIcon-root": {
    position: "absolute",
    left: theme.spacing(2),
  },
  "& .MuiInputBase-input::placeholder": {
    color: "#313131",
    opacity: 1,
    fontWeight: 500,
    fontSize: "16px",
  },
}));

export const AddPayoutAccountModal: React.FC<AddPayoutAccountModalProps> = ({
  open,
  handleClose,
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={styleSheet.container}>
        <Box display="flex" justifyContent="flex-end">
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          textAlign="center"
          flexDirection="column"
        >
          <Typography
            fontWeight={{ xs: 700, md: 500 }}
            fontSize={{ xs: 18, md: 28 }}
            color={{ xs: "#313131", md: "#233F91" }}
          >
            Add a Payout Account
          </Typography>
        </Box>
        <Box display="flex" flexDirection="column" gap={3}>
          <Grid py={3} display="flex" gap={2} alignItems="center">
            <CustomTextField
              name="amount"
              sx={{ width: "547px" }}
              value={""}
              onChange={() => { }}
              placeholder="Bank Account"
              InputProps={{
                startAdornment: (
                  <img
                    src="/assets/icons/guidanceBank.png"
                    alt="guidanceBank"
                    style={{
                      width: "24px",
                      height: "23px",
                      marginRight: "8px",
                    }}
                  />
                ),
              }}
            />
          </Grid>
          <Box display="flex" justifyContent="flex-end" gap={{ xs: 1, md: 4 }}>
            <Button onClick={handleClose} sx={styleSheet.closeBtn}>
              Back
            </Button>
            <Button
              sx={styleSheet.saveBtn}
            // onClick={onSubmit}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

const styleSheet = {
  container: {
    position: "absolute",
    top: { xs: "356px", md: "50%" },
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "292px", md: "500px" },
    maxHeight: { xs: "100vh", md: "100vh" },
    overflow: "auto",
    bgcolor: "background.paper",
    boxShadow: 24,
    p: { xs: 4, md: 4 },
    borderRadius: "10px",
  },
  closeBtn: {
    bgcolor: "#EEEEEE",
    color: "#233f91",
    width: "87px",
    height: "48px",
    border: "1.5px solid #233F91",
    borderRadius: "15px",
    "&:hover": {
      bgcolor: "#cccccc",
    },
  },
  saveBtn: {
    bgcolor: "#233f91",
    color: "#fff",
    width: "83px",
    height: "48px",
    borderRadius: "15px",
    "&:hover": {
      bgcolor: "#1565c0",
      color: "#fff",
    },
  },
};
